export default function Serializable() {}